import { AccountantIntegration } from '../../types'
import request, { AccountantApiError, csrfToken } from './request'

export default class IntegrationsController {
  static getIntegrations(workspaceId: string): Promise<AccountantIntegration[]> {
    return request(`/api/workspaces/${workspaceId}/integrations`)
  }

  // Uses fetch directly: request() treats 422 as a form response and we need 429 to throw.
  static async requestActivation(workspaceId: string, type: string): Promise<AccountantIntegration> {
    const res = await fetch(`/api/workspaces/${workspaceId}/integrations/${type}/request`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
      credentials: 'same-origin',
    })
    if (res.status === 401) {
      window.location.assign('/sign_in')
      throw new AccountantApiError(res.status)
    }
    if (!res.ok) throw new AccountantApiError(res.status)

    return res.json()
  }
}
